import { render, staticRenderFns } from "./prizes.vue?vue&type=template&id=0c140dce"
import script from "./prizes.vue?vue&type=script&lang=js"
export * from "./prizes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports